import { useApplicationField } from '../useApplicationField';

// ─── Legality ─────────────────────────────────────────────────────────────────

export const useBorrowerIsDefendantInLegalActions = () =>
    useApplicationField(
        (d) => d.information.borrower.currentlyQuestions.defendantInLegalActions,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, currentlyQuestions: { ...d.information.borrower.currentlyQuestions, defendantInLegalActions: v } } } })
    );

export const useBorrowerIsDelinquentOnDebts = () =>
    useApplicationField(
        (d) => d.information.borrower.currentlyQuestions.delinquentOnDebts,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, currentlyQuestions: { ...d.information.borrower.currentlyQuestions, delinquentOnDebts: v } } } })
    );

export const useBorrowerIsDelinquentOnTaxes = () =>
    useApplicationField(
        (d) => d.information.borrower.currentlyQuestions.delinquentOnTaxes,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, currentlyQuestions: { ...d.information.borrower.currentlyQuestions, delinquentOnTaxes: v } } } })
    );

export const useBorrowerIsFinanciallyWorseOff = () =>
    useApplicationField(
        (d) => d.information.borrower.currentlyQuestions.financiallyWorseOff,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, currentlyQuestions: { ...d.information.borrower.currentlyQuestions, financiallyWorseOff: v } } } })
    );

export const useBorrowerIsInvolvedInJudgements = () =>
    useApplicationField(
        (d) => d.information.borrower.currentlyQuestions.involvedInJudgements,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, currentlyQuestions: { ...d.information.borrower.currentlyQuestions, involvedInJudgements: v } } } })
    );

export const useBorrowerLegalExplanations = () =>
    useApplicationField(
        (d) => d.information.borrower.currentlyQuestions.explanations,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, currentlyQuestions: { ...d.information.borrower.currentlyQuestions, explanations: v } } } })
    );
